module.exports = "/assets/368ddb131983e6c6158462677ffbfd33.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/IO.png
// module id = 1481
// module chunks = 0